<stx-generic-wide-page>
  <stx-report-header>
    {{ 'reports.orthognatic_speech_stats_header' | translate }}
  </stx-report-header>
  <stx-report-filters [reportConfig]="reportConfig" (applyFilters)="applyFilters($event)"></stx-report-filters>

  @if (reportService.filtersReady$ | async) {
  <stx-speech-stats-report-table></stx-speech-stats-report-table>
  }
</stx-generic-wide-page>
